import { MutationTree } from 'vuex';
import {AttributesState} from '.';
import {ADD_TO_CONTACT_ATTRIBUTE_CACHE, SET_CONTACT_ATTRIBUTES, UPDATE_CONTACT_ATTRIBUTE_IN_CACHE, ARCHIVE_CONTACT_ATTRIBUTE_IN_CACHE} from '@/store/attributes/mutationTypes';
import {ContactAttributeViewModel} from '@/messaging/models/contactAttributeViewModel';

export const mutations: MutationTree<AttributesState> = {
	[SET_CONTACT_ATTRIBUTES](state, attributes: ContactAttributeViewModel[]) {
		state.contactAttributes = attributes;
	},

	[ADD_TO_CONTACT_ATTRIBUTE_CACHE](state, newAttribute: ContactAttributeViewModel) {
		state.contactAttributes.push(newAttribute);

		const systemAttributes = state.contactAttributes.filter(att => att.system);
		const customAttributesOrderedByName = state.contactAttributes.filter(att => !att.system).sort((a, b) => a.name.localeCompare(b.name));
		state.contactAttributes = [...systemAttributes, ...customAttributesOrderedByName];
	},

	[UPDATE_CONTACT_ATTRIBUTE_IN_CACHE](state, updateAttribute: ContactAttributeViewModel) {
		const attributeInCache = state.contactAttributes.find(att => att.id === updateAttribute.id) as ContactAttributeViewModel;
		attributeInCache.description = updateAttribute.description;
		attributeInCache.name = updateAttribute.name;
	},

	[ARCHIVE_CONTACT_ATTRIBUTE_IN_CACHE](state, attributeId: string) {
		const attributeInCache = state.contactAttributes.find(att => att.id === attributeId) as ContactAttributeViewModel;
		attributeInCache.archived = true;
	}
};
